import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { usePortalLinkContext } from '~/components/PortalLink';
import { NotificationArea, NotificationSubArea } from '~/services/Http';
import { browserLogError } from '~/utils/helper';

export const useReportNavigateToView = () => {
  // Navigate in UI2 & as library component without reloading
  const { isRouteLinksEnabled, onLegacyNavigate } = usePortalLinkContext();
  const history = useHistory();

  const isDevelopmentEnvironment = process.env.NODE_ENV === 'development';

  const goToEmployeeBasicDataView = useCallback(
    (employeeId: number) => {
      if (!!onLegacyNavigate) {
        // Library component navigation logic
        onLegacyNavigate({
          area: NotificationArea.PEOPLE,
          subarea: NotificationSubArea.BASIC_DATA,
          empId: employeeId,
        });
      } else if (isRouteLinksEnabled) {
        if (isDevelopmentEnvironment) {
          // UI2 view Route navigation logic to UI2 views
          history.push(`/portal/employee/${employeeId}/people/basic`);
        } else {
          // TODO Window Redirect logic from UI2 to Legacy views
          browserLogError(
            'Report Link navigation case for window redirect logic not yet implemented',
          );
        }
      } else {
        browserLogError('Report Link navigation configuration error');
      }
    },
    [isRouteLinksEnabled, onLegacyNavigate, history, isDevelopmentEnvironment],
  );

  return {
    goToEmployeeBasicDataView,
  };
};
